export default __webpack_public_path__ + "static/FancyMediaContentFour-ed040cdc2cbf9959e644ffff58276c49.webp";